import { Record } from 'immutable';

class SharePermission extends Record(
  {
    id: null,
    shareParticipantId: null,
    action: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
    deletedAt: null,
    deletedBy: null
  },
  'SharePermission'
) {}

export { SharePermission };
